import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnDestroy, ViewEncapsulation, Self } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { UMPAction, UMPCategory, Utils } from '../../../../utils/utils';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomDialogService } from '../../../../services/customdialog.service';
import { DeleteUserDialogue } from './deleteuserdialogue/deleteuserdialogue.component';
import { AddGroupDialogue } from './addgroupdialogue/addgroupdialogue.component';
import { UMPBranchHierarchy } from './umpbranchhierarchy/umpbranchhierarchy.component'
import { SpinnerOverlayService } from '../../../../services/spinner-overlay.service';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';
import { ComponentTool } from '../../../../interfaces/componenttool';
import { CacheInfoDialogue } from './cacheinfodialogue/cacheinfodialogue.component';
import { SaveService } from '../../../../services/save.service';
import { ResetPwdDialogue } from './resetpwddialogue/resetpwddialogue.component';
import { UserHistoryDialogue } from './userhistorydialogue/userhistorydialogue.component';
import { DialogService } from '../../../../services/dialog.service';
import { environment } from '../../../../../environments/environment';
import { DestroyService } from '../../../../services/destroyservice';
import { CanComponentDeactivate } from '../../../../guards/unsaved-changes.guard';
import { Observable, Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AzureAdUserLimits } from '../adduser/common_form_tools';

@Component({
    selector: "edituser",
    templateUrl: './edituser.component.html',
    styleUrls: ['./edituser.component.less',
        '../../../../style/new-generic-styles.component.less'],
    providers: [UMPBranchHierarchy, DestroyService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class EditUserComponent implements OnDestroy, CanComponentDeactivate {
    public editUserForm!: FormGroup;
    public userFormCopy: any;
    limits = AzureAdUserLimits;

    public isProductionEnvironment = environment.production;
    public userName: String = '';
    options: any[] = [{ _id: '1', status: 'waiting' },
    { _id: '2', status: 'open' },
    { _id: '3', status: 'in_progress' },
    { _id: '4', status: 'close' }];
    selectedSecTenString = '';
    selectedMfgCenterString = '';
    userId = ''

    Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API

    errorResponse: any;
    errorMessage: string = '';
    isCallSucceed: number = 0;
    isCallSucceedResInv: number = 0;

    roleSearchValue: string = '';

    filteredDirectRoleItems: any[] = [];
    filteredInDirRoleItems: any[] = [];
    fullDirectRoleItems: any[] = [];
    fullInDirRoleItems: any[] = [];

    userRoles: any[] = [];

    dialogRef: MatDialogRef<ResetPwdDialogue, any> | undefined
    deldialogRef: MatDialogRef<DeleteUserDialogue, any> | undefined
    
    addgrpdialogRef: MatDialogRef<AddGroupDialogue, any> | undefined
    cachegroupDialogRef: MatDialogRef<CacheInfoDialogue, any> | undefined
    
    userhistorydialogRef: MatDialogRef<UserHistoryDialogue, any> | undefined
    textIconItemArray: TextIconItem[] = [];
    
    AllAzDevProj = [];
    UserAzDevProj = [];
    RemainAzDevProj = [];
    
    reload = -1;
    resetAllCommand = true;
    disableSaveButton = true;
    
    selectedParentId: string | null = null;

    userDetails: UserDetails = {
        active: false,
        displayName: '',
        email: '',
        firstName: '',
        mersyAccessReport: false,
        mersyAccessReportDev: false,
        marketQueryAccessReport: false,
        eoxNiOpsAccessReport: false,
        isEditable: false,
        isExternalUser: false,
        isPendingAcceptance: false,
        lastName: '',
        secondaryTenants: [],
        tenant: '',
        usageLocation: '',
        userEmail: '',
        otherEmails: null,
        userPrincipalName: '',
        secondaryTenantsSelectList: [],
        tenantsSelectList: [],
        companyName: '',
        creationType: '',
        manufacturingCenters: [],
        mfgCentersSelectList: [],
        MgmtId: [],
        locationSelectList: [],
    }
    

    componentToolEnum: typeof ComponentTool = ComponentTool;
    showSearchAddon: boolean = false;
    stickyPinned = false;

    secTenantSet = new Set<string>();
    initialPrimTen = "";

    mfgCenterSet = new Set<string>();
    availableCenters: MfgCenter[] = [];
    isMersyTool = false;

    //Add variable to hide userLicenses sections as it is unused for now
    hideUserLicensesSection: boolean = true;

    // Subscription for form valueChanges - must be unsubscribed on form recreation
    private formChangesSubscription?: Subscription;
    
    // Subject for canDeactivate dialog response
    private deactivateResponse$ = new Subject<boolean>();
    private isDeactivating = false;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private http: HttpClient,
        private toastrService: ToastrService,
        private dialogForm: MatDialog,
        private umpbranchheir: UMPBranchHierarchy,
        @Inject('BASE_URL') private baseUrl: string,
        private spinnerOverlayService: SpinnerOverlayService,
        public defaults: DefaultValuesService,
        private customDialog: CustomDialogService,
        public saveService: SaveService,
        public topDetlRef: ElementRef,
        private groupmgmtresponseDialog: DialogService,
        @Self() private readonly destroy$: DestroyService

    ) {
        this.groupmgmtresponseDialog.showTypeIcon = false;
        this.isMersyTool = this.defaults.componentTool === this.componentToolEnum.Mersy;
        this.route.params.subscribe(() => this.constructorfunc());
    }

    private buildEditUserForm(): FormGroup {
        return this.fb.group({
            firstName: ['', [Validators.maxLength(AzureAdUserLimits.GivenName)]],
            email: ['', [Validators.maxLength(AzureAdUserLimits.Mail)]],
            otherEmails: [null],
            lastName: ['', [Validators.maxLength(AzureAdUserLimits.Surname)]],
            displayName: ['', [Validators.required, Validators.maxLength(AzureAdUserLimits.DisplayName)]],
            tenant: [null],
            secondaryTenants: [null],
            manufacturingCenters: [null],
            active: [false],
            mersyAccessReport: [false],
            mersyAccessReportDev: [false],
            marketQueryAccessReport: [false],
            eoxNiOpsAccessReport: [false],
            isexternaluser: [null],
            companyName: ['', [Validators.maxLength(AzureAdUserLimits.CompanyName)]],
            creationType: [''],
            MgmtId: [null],
            usageLocation: [null, this.isMersyTool ? [Validators.required] : []],
        });
    }

    constructorfunc() {
        this.userDetails.userPrincipalName = '';
        this.userDetails.isPendingAcceptance = false;
        this.initialPrimTen = '';
        this.disableSaveButton = true;
        this.userFormCopy = null;
        this.formChangesSubscription?.unsubscribe();
        this.saveService.removeListener(this);

        this.editUserForm = this.buildEditUserForm();

        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        this.funcGetUserDetails();
        if (this.defaults.componentTool === this.componentToolEnum.Rulebook) {
            this.getCenters();
        }
    }

    ngOnDestroy(): void {
        this.formChangesSubscription?.unsubscribe();
        
        if (this.isDeactivating) {
            this.deactivateResponse$.next(true);
        }
        this.deactivateResponse$.complete();
        
        this.saveService.removeListener(this);
        if (this.saveService.listeners.length === 0) {
            this.saveService.showSaveButton(false);
        }
    }

    canDeactivate(): boolean | Observable<boolean> {
        const hasUnsavedChanges = !this.disableSaveButton || this.saveService.listeners.length > 0;

        if (!hasUnsavedChanges) {
            return true;
        }

        this.isDeactivating = true;
        this.groupmgmtresponseDialog.extraClasses = ['edituser-confirm-dialog'];
        this.groupmgmtresponseDialog.showConfirmDialog(
            'You have unsaved changes. Click Yes to save, or No to discard and leave.',
            'Unsaved Changes',
            this
        );

        return this.deactivateResponse$.pipe(take(1));
    }

    onYes(): void {
        if (this.isDeactivating) {
            this.isDeactivating = false;
            this.saveService.fireSave(-1, this);
            this.deactivateResponse$.next(true);
        }
    }

    onNo(): void {
        if (this.isDeactivating) {
            this.isDeactivating = false;
            this.saveService.fireCancelAll();
            this.deactivateResponse$.next(true);
        }
    }

    onStickyTrigger(): void {
        var el2
        const el = this.topDetlRef.nativeElement.querySelector('.stickyTopDetls');
        this.defaults.componentTool === this.componentToolEnum.Rulebook ? el2 = this.topDetlRef.nativeElement.querySelector('.stickyTopBtns') : el2 = null;
        const observer = new IntersectionObserver(
            ([e]) => {
                e.target.classList.toggle('is-pinned', e.intersectionRatio < 1)
                el2?.classList.toggle("is-pinned", e.intersectionRatio < 1);
                e.intersectionRatio < 1 ? this.stickyPinned = true : this.stickyPinned = false;
            },
            { threshold: [1] }
        );

        observer.observe(el);
    }

    onSecTenChange() {
        this.selectedSecTenString = this.editUserForm.controls['secondaryTenants'].value.map(item => item).join(', ');
    }

    onMfgCenterChange() {
        this.selectedMfgCenterString = this.editUserForm.controls['manufacturingCenters'].value.map(item => item).join(', ');
    }

    onSave() {
        this.disableSaveButton = true;
        this.isCallSucceed = 0;
        var formvalues = this.editUserForm.getRawValue();
        //formvalues.secondaryTenants = this.removePrimaryTenant(formvalues.tenant, formvalues.secondaryTenants);
        formvalues.secondaryTenants = this.removePrimaryTenant(formvalues.tenant, Array.from(this.secTenantSet.values()));
        formvalues.MgmtId = (formvalues.MgmtId || []);

        if (!this.hasOtherEmails()) {
            formvalues.otherEmails = null;
        }

        Utils.httpUpdateUser(
            this.http
            , this.baseUrl
            , formvalues
            , this.userId
            , UMPCategory.UserDetails
            , UMPAction.Update
            , this
            , function (tthis: EditUserComponent) {
                tthis.resetInitialFilters()
                tthis.reload = Math.random()
                tthis.funcNotify();
                tthis.funcGetUserDetails();          
                tthis.umpbranchheir.ngOnInit();
                tthis.secTenantSet?.clear()
            }
        )
    }

    removePrimaryTenant(primaryTen: string, secTen: string[]): string[] {
        return secTen.filter(item => item !== primaryTen);
    }

    funcGetUserDetails() {
        this.disableSaveButton = true;
        Utils.httpGetUserDetails(
            this.http
            , this.baseUrl
            , this.userId
            , this
            , async function (tthis: EditUserComponent, data: UserDetails) {
                tthis.userDetails = data;
                tthis.editUserForm.patchValue({
                    firstName: data.firstName,
                    email: data.email ?? data.userEmail,
                    otherEmails: data.otherEmails ?? [],
                    lastName: data.lastName,
                    displayName: data.displayName,
                    tenant: data.tenant,
                    secondaryTenants: data.secondaryTenants,
                    active: data.active,
                    mersyAccessReport: data.mersyAccessReport,
                    mersyAccessReportDev: data.mersyAccessReportDev,
                    marketQueryAccessReport: data.marketQueryAccessReport,
                    eoxNiOpsAccessReport: data.eoxNiOpsAccessReport,
                    isexternaluser: data.isExternalUser,
                    companyName: data.companyName,
                    manufacturingCenters: data.manufacturingCenters,
                    MgmtId: data.MgmtId,
                    creationType: data.creationType,
                    usageLocation: data.usageLocation,
                }, { emitEvent: false });
                tthis.userFormCopy = tthis.editUserForm.getRawValue();
                tthis.initialPrimTen = tthis.editUserForm.controls['tenant'].value;
                tthis.subscribeChanges();
                if (!tthis.defaults.isDataAnalytStage()) {
                    tthis.selectAllForDropdownItems(tthis.userDetails.secondaryTenantsSelectList);
                    tthis.secTenantSet = new Set(tthis.userDetails.secondaryTenants);
                }
                setTimeout(() => {
                    tthis.onStickyTrigger();
                }, 1000);

            }, this.defaults.isDataAnalytStage()
        )
    }
    selectAllForDropdownItems(items) {

        let allSelect = items => {
            items.forEach(element => {
                element['selectedAllGroup'] = 'selectedAllGroup';
            });
        };

        allSelect(items);
    }
    subscribeChanges() {
        if (this.formChangesSubscription && !this.formChangesSubscription.closed) return;
        
        this.formChangesSubscription = this.editUserForm.valueChanges.subscribe(changes => {
            if (!this.userFormCopy) return;
            
            const hasChanges = Object.keys(this.editUserForm.controls)
                .some(field => this.userFormCopy[field] !== changes[field]);
            
            if (hasChanges) {
                this.disableSaveButton = false;
                this.saveService.addListener(this);
            }
        });
    }

    funcNotifyResendInvite() {
        if (this.isCallSucceedResInv === 1) {
            this.toastrService.success('User invitation request sent successfully !', 'User Invitation Request!');
        }
        else if (this.isCallSucceedResInv === -1) {
            this.toastrService.error('User invitation request not sent successfully !', 'User Invitation Request!');
        }
    }

    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('User Details update request sent successfully !', 'User Edit Request!');
        }
        else if (this.isCallSucceed === -1) {
            const detail = this.errorMessage && this.errorMessage.trim() !== ''
                ? this.errorMessage
                : 'User Details update request not sent successfully !';
            this.toastrService.error(detail, 'User Edit Request!');
        }
    }

    getCenters() {
        Utils.httpGetMfgcenters(this.http,
            this.baseUrl,
            this,
            function (tthis: EditUserComponent, result: MfgCenters) {
                tthis.availableCenters = result.centersList;
            }
        );
    }

    handleresetbutton(event: any) {
        event.preventDefault();

        this.dialogRef = this.dialogForm.open(ResetPwdDialogue, {
            //minHeight: '340px',
            //minWidth: '600px',
            data: { userId: this.userId, useremail: this.getActiveEmail() },
            disableClose: true
        });
    }
    handledelbutton(event: any) {
        event.preventDefault();

        this.deldialogRef = this.dialogForm.open(DeleteUserDialogue, {
            data: { userId: this.userId, useremail: this.getActiveEmail() }
        });
    }
    handleResendIvite() {
        this.isCallSucceedResInv = 0;
        Utils.httpResentInvitation(
            this.http
            , this.baseUrl
            , { DisplayName: this.userDetails.displayName, UserEmailAddress: this.getActiveEmail(), SendInvitationMessage: true }
            , this
            , function (tthis: EditUserComponent, data: any) {
                tthis.funcNotifyResendInvite();

            }
        )

    }
    onOpenScrollbar() {
        setTimeout(() => {
            const scrollContainer = document.querySelector('.ng-dropdown-panel-items');
            if (scrollContainer) {
                scrollContainer.scrollTop = 0;
            }
        }, 0);
    }

    resetInitialFilters() {
        // Reseting initial filters when user modify his account
        if (this.userDetails.userEmail.toUpperCase() === this.defaults.session?.UserUPN.toUpperCase())
            this.defaults.umpFilters = {
                cdpList: [],
                nodeId: [],
                nodes: [],
                page: 0,
                pageSize: 12,
                personaId: [],
                personas: [],
                tenant: [],
                tenants: [],
                userPrincipalName: ''
            };

    }

    showSearchAddonMethod() {
        this.showSearchAddon = !this.showSearchAddon;
    }

    clearCacheUser($event: any) {
        $event.preventDefault()
        this.customDialog.openConfirm({
            title: "Clear Cache user",
            message: `Process will reset cache information for that user. Do you want to continue?`,
            caller: this
        });
        this.customDialog.confirmed().subscribe(res => {
            if (res.confirmed) {
                Utils.httpClearCacheByUser(
                    this.http
                    , this.baseUrl
                    , this.userId
                    , this
                    , function (tthis: EditUserComponent) {
                        if (tthis.isCallSucceed === 1) {
                            tthis.toastrService.success('User cache cleared successfully !', 'User Cache Request!');
                        }
                        else if (tthis.isCallSucceed === -1) {
                            tthis.toastrService.error('User cache did not clear successfully !', 'User Cache Request!');
                        }
                    }
                    , this.defaults.isDataAnalytStage()
                )
            }
        })
    }

    getUserCache($event: any) {
        $event.preventDefault();
        this.cachegroupDialogRef = this.dialogForm.open(CacheInfoDialogue, {
            height: '700px',
            width: '800px',
            data: { userId: this.userId },
            disableClose: true
        });
        this.cachegroupDialogRef.afterClosed().subscribe(() => {

        });
    }


    updateTenSet(eventData: { selTen: string[], checked: boolean }) {
        eventData.selTen.forEach((ten) => { eventData.checked ? this.secTenantSet.add(ten) : this.secTenantSet.delete(ten) })
        this.disableSaveButton = false;
        this.saveService.addListener(this)
    }
    onMgmtIdUpdate(event: { mgmtIds: string[], checked: boolean }) {
        console.log(event)
        let currentMgmtIds = this.editUserForm.controls['MgmtId'].value || [];
        if (event.checked) {
            // Add new MgmtIds, avoiding duplicates
            currentMgmtIds = Array.from(new Set([...currentMgmtIds, ...event.mgmtIds]));
        } else {
            // Remove unselected MgmtIds
            currentMgmtIds = currentMgmtIds.filter((id: string) => !event.mgmtIds.includes(id));
        }
        this.editUserForm.controls['MgmtId'].setValue(currentMgmtIds);
        this.disableSaveButton = false;
        this.saveService.addListener(this);
        console.log('MgmtId list after branch selection:', currentMgmtIds);
    }
    onPrimTenChange(newTen) {
        this.secTenantSet.add(this.initialPrimTen);
        this.secTenantSet.delete(newTen);
    }

    updateMfgCenterSet(eventData: { selMfgCenter: string[], checked: boolean }) {
        eventData.selMfgCenter.forEach((mfgCenter) => { eventData.checked ? this.mfgCenterSet.add(mfgCenter) : this.mfgCenterSet.delete(mfgCenter) })
        this.disableSaveButton = false;
        this.saveService.addListener(this)
    }

    checkUserHistory($event: any) {
        $event.preventDefault();
        this.userhistorydialogRef = this.dialogForm.open(UserHistoryDialogue, {
            height: '525px',
            width: '1500px',
            data: { userId: this.userId },
            disableClose: true
        });
        this.userhistorydialogRef.afterClosed().subscribe(() => {
        });
    }

    public groupMgmtCallback = (data: GroupUserManagementResponse) => {
        if (data) {
            let show = this.textIconItemArray.length == 0;
            Object.keys(data.isSuccessfullyAppliedToGroup).forEach(key => {
                let item: TextIconItem = {
                    text: key,
                    matIcon: data.isSuccessfullyAppliedToGroup[key] ? 'check' : 'cancel',
                    iconClass: data.isSuccessfullyAppliedToGroup[key] ? 'green bottom' : 'red bottom'
                };
                this.textIconItemArray.push(item);
            });
            this.groupmgmtresponseDialog.text_icon_items = this.textIconItemArray;
            if (show) {
                this.groupmgmtresponseDialog.tthis = this;
                this.groupmgmtresponseDialog.extraClasses = ['edituser-confirm-dialog'];
                this.groupmgmtresponseDialog.showSuccessDialog("", `Group action result status:`);
            }
        }
    };

    onBack(ref?: any) {
        if (this.isDeactivating) {
            this.isDeactivating = false;
            this.deactivateResponse$.next(false);
            return;
        }

        this.defaults.clearGroupListItem();
        this.defaults.resetUserSearchSource.next(true);
        this.textIconItemArray = [] as TextIconItem[];
        this.groupmgmtresponseDialog.text_icon_items = this.textIconItemArray;
        this.groupmgmtresponseDialog.extraClasses = undefined;
    }

    onMersyDirectClick(event: any, type: number) {
        Utils.httpEnableDisablePowerBiUser(
            this.http
            , this.baseUrl
            , this.userId
            , type
            , event.checked
            , this
            , function (tthis: EditUserComponent) {
                tthis.defaults.notifydataAnalyticsTreeSourceChange();
                tthis.toastrService.success(`Group was ${event.checked === true ? 'assigned' : 'unassigned'} successfully !`, 'Group assigment Request!');
            }
            , this.getActiveEmail()
        )
    }

    hasOtherEmails() {
        return this.userDetails.otherEmails != null && this.userDetails.otherEmails.length > 1;
    }

    /**
     * Returns the email the view should act upon (reset password, resend invite,
     * delete confirmation). When the user has more than one email, this is the one
     * currently selected in the Username dropdown; otherwise it falls back to the
     * primary userEmail.
     */
    getActiveEmail(): string {
        const selected = this.editUserForm?.controls['email']?.value;
        return this.hasOtherEmails() && selected ? selected : this.userDetails.userEmail;
    }
}